export const MAX_PAGES = 10;
export const HALF_MAX_PAGES = MAX_PAGES / 2;
export const MIN_PAGE_TO_FIRST_PAGE = {
    TOUCH: 3,
    DESKTOP: HALF_MAX_PAGES + 2,
};
